import React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveTeam, selectActiveTeamPlayersOnTheFieldOptions } from 'features/match/matchSlice';

import { selectSelects } from 'features/input/inputSlice';

import AdvancedSelect from 'components/AdvancedSelect';

import { useIntl } from 'react-intl';
import generateSelectPlaceholder from '../../../helpers/generateSelectPlaceholder';

const EventInputPenaltiesGoal: React.FC = () => {
  const intl = useIntl();

  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayersOnTheFieldOptions);
  const team: any = useSelector(selectActiveTeam);

  if (!team) return null;

  const teamName = team.shortName ? team.shortName : team.name;
  const playerMessage = intl.formatMessage({ id: 'eventInput.player' });

  return (
    <div className="input-group penalties-goal">
      <div className="inputsLine">
        <AdvancedSelect
          title={intl.formatMessage({ id: 'selectHeader.playerPenaltyTaker' })}
          placeholder={generateSelectPlaceholder(intl, playerMessage, teamName)}
          options={playerOptions}
          select={selects.playerPenaltyTaker}
          isClearable={false}
          disabled={true}
        />
      </div>
    </div>
  );
};

export default EventInputPenaltiesGoal;
